import React from "react";
import { ArrowRight, Activity, Wind, Zap, Heart, Info } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HealingStartMainBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const subNavItems = [];
  return;
}